import { LineChartInputData } from '@modules/charts/types';

export const isLineChartInputData = (
  obj:
    | string
    | number
    | boolean
    | Pick<LineChartInputData, 'id' | 'value' | 'anomalyValue'>,
): obj is Pick<LineChartInputData, 'id' | 'value' | 'anomalyValue'> => {
  return (
    typeof obj === 'object' &&
    (obj as Pick<LineChartInputData, 'id'>).id !== undefined &&
    typeof (obj as Pick<LineChartInputData, 'id'>).id === 'string'
  );
};
